module.exports = __webpack_public_path__ + "img/vr3.f66b9ace.jpg";